import { render } from "./InterfaceUsersOnRoute.vue?vue&type=template&id=6437707e&scoped=true"
import script from "./InterfaceUsersOnRoute.vue?vue&type=script&lang=js"
export * from "./InterfaceUsersOnRoute.vue?vue&type=script&lang=js"

import "./InterfaceUsersOnRoute.vue?vue&type=style&index=0&id=6437707e&scoped=true&lang=scss"

import exportComponent from "/tmp/b7562a83-daa0-4796-bff7-c3f4922e39c8/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6437707e"]])

export default __exports__